var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"graficaModal",attrs:{"size":"xl","hide-footer":"","no-close-on-backdrop":"","title":"Gráfica de Línea"}},[_c('chartLine',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }